module.exports = __webpack_public_path__ + "media/images/light_grey_2_line_dots_side-57695825aa1a74ff78e2358d6ca423f7.svg";